import dragonBones from 'pixi-dragonbones';
import DragonbonesAnimationEvent from './DragonbonesAnimationEvent';

export const fingerprintMissingDBArmature = 'DBMissingArmature' as const;
export const defaultDBAnimationName = 'animation';

export function* yieldUntilComplete(
    armatureDisplay: dragonBones.PixiArmatureDisplay
): IterableIterator<number> {
    let complete = false;
    const onComplete = () => {
        complete = true;
        armatureDisplay.removeDBEventListener(
            DragonbonesAnimationEvent.COMPLETE,
            onComplete,
            armatureDisplay
        );
    };

    armatureDisplay.addDBEventListener(
        DragonbonesAnimationEvent.COMPLETE,
        onComplete,
        armatureDisplay
    );

    while (!complete) yield;
}
